module.exports = __webpack_public_path__ + "static/media/invitado.18629a73.webp";